module.exports = __webpack_public_path__ + "img/속초 물회 맛집.7db0ddeb.png";